export default __webpack_public_path__ + "3c7750063726873857ced1e502ffa630.png";